import { SORT_ORDER } from '@/shared/constants/sort/sortOrder'
import { SORT_DIRECTION } from '@/shared/constants/sort/sortDirection'

export default {
  SET_FORM_DATA(state, payload) {
    state.formData = { ...state.formData, ...payload }
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ACTION_LOADING(state, status) {
    state.actionLoading = status
  },
  SET_ITEMS(state, payload) {
    state.items = [...state.items, ...payload.keys]
    state.total = payload.total || 100
  },
  RESET_FILTERS_AND_SORTING(state) {
    state.range = []
    state.sorting = [
      {
        sort_by: SORT_ORDER.CREATED_AT,
        sort_direction: SORT_DIRECTION.DESC,
      },
    ]
  },
  SET_RANGE(state, payload) {
    state.range = payload
  },
  SET_PAGE(state, payload) {
    state.page = payload
  },
  RESET_PAGE(state) {
    state.page = 1
    state.limit = 10
    state.items = []
  },
  SET_SORTING(state, payload) {
    state.sorting = payload
  },
  UPDATE_ITEMS_AFTER_DELETE(state, api_key) {
    state.items = state.items.filter((item) => item.api_key !== api_key)
  },
  SET_ID(state, payload) {
    state.id = payload
  },
  RESET_STORE(state) {
    state.formData = null
    state.loading = false
    state.actionLoading = false
    state.sorting = {
      sort_by: SORT_ORDER.CREATED_AT,
      sort_direction: SORT_DIRECTION.DESC,
    }

    state.limit = 10
    state.items = []
    state.page = 1
    state.total = 10
    state.range = []
  },
}
